import { Activity, Emotion } from '../types';

export const ACTIVITIES: Activity[] = [
  {
    id: 'meditation',
    name: '명상',
    description: '마음을 정리하고 평온을 찾아보세요',
    icon: '🧘',
    color: 'bg-blue-100 text-blue-600'
  },
  {
    id: 'breathing',
    name: '심호흡',
    description: '깊은 호흡으로 마음을 가라앉혀보세요',
    icon: '🫁',
    color: 'bg-green-100 text-green-600'
  },
  {
    id: 'piano',
    name: '피아노',
    description: '음악으로 감정을 표현해보세요',
    icon: '🎹',
    color: 'bg-purple-100 text-purple-600'
  },
  {
    id: 'sketch',
    name: '스케치',
    description: '그림으로 마음을 그려보세요',
    icon: '🎨',
    color: 'bg-orange-100 text-orange-600'
  },
  {
    id: 'voice',
    name: '음성',
    description: '음성으로 감정을 녹음해보세요',
    icon: '🎤',
    color: 'bg-pink-100 text-pink-600'
  },
  {
    id: 'writing',
    name: '글쓰기',
    description: '글쓰기로 생각을 정리해보세요',
    icon: '✍️',
    color: 'bg-yellow-100 text-yellow-600'
  }
];

export const EMOTIONS: Emotion[] = [
  {
    id: 'happy',
    name: '행복',
    color: 'bg-yellow-100 text-yellow-600'
  },
  {
    id: 'sad',
    name: '슬픔',
    color: 'bg-blue-100 text-blue-600'
  },
  {
    id: 'angry',
    name: '화남',
    color: 'bg-red-100 text-red-600'
  },
  {
    id: 'anxious',
    name: '불안',
    color: 'bg-orange-100 text-orange-600'
  },
  {
    id: 'excited',
    name: '설렘',
    color: 'bg-pink-100 text-pink-600'
  },
  {
    id: 'relaxed',
    name: '평온',
    color: 'bg-green-100 text-green-600'
  },
  {
    id: 'frustrated',
    name: '답답',
    color: 'bg-gray-100 text-gray-600'
  },
  {
    id: 'tired',
    name: '피곤',
    color: 'bg-indigo-100 text-indigo-600'
  },
  {
    id: 'neutral',
    name: '보통',
    color: 'bg-gray-100 text-gray-600'
  }
];

export const LANGUAGES = [
  {
    code: 'ko',
    name: '한국어',
    flag: '🇰🇷'
  },
  {
    code: 'en',
    name: 'English',
    flag: '🇺🇸'
  },
  {
    code: 'es',
    name: 'Español',
    flag: '🇪🇸'
  }
]; 